<script>
import TitleWithRow from '@/components(new)/UI/Typography/TitleWithRow/TitleWithRow.vue'
import Label from '@/components(new)/UI/Forms/Label/Label.vue'
import InputSelect from '@/components(new)/UI/Forms/InputSelect/InputSelect.vue'
import InputMultiTexts from '@/components(new)/UI/Forms/InputMultiTexts/InputMultiTexts.vue'
import InputDouble from '@/components(new)/UI/Forms/InputDouble/InputDouble.vue'
import Card from '@/components(new)/UI/Cards/Card/Card.vue'
import Irrigacao from '@/components(new)/UI/Forms/FormulariosProntos/Irrigacao/Irrigacao.vue'
import Financiamentos from '@/components(new)/UI/Forms/FormulariosProntos/Financiamentos/Financiamentos.vue'
import onlyInputNumbers from '@/components/mixins/OnlyInputNumber'
import { opcoesSimNao,
  opcoesFonteAguaUtilizada, opcoesCaptacaoLicenciada, opcoesTipoSistemaTI, opcoesTipoAlimentacao, opcoesEspecies
} from '@/libs/constants/praticas/opcoesSelects'

export default {
  mixins: [onlyInputNumbers],
  components: {
    TitleWithRow,
    Label,
    InputSelect,
    InputMultiTexts,
    InputDouble,
    Card,
    Irrigacao,
    Financiamentos
  },
  data () {
    return {
      nomeAba: 'Práticas',
      opcoesSimNao,
      opcoesFonteAguaUtilizada,
      opcoesCaptacaoLicenciada,
      opcoesTipoSistemaTI,
      opcoesTipoAlimentacao,
      opcoesEspecies,
      especiesRacas: {
        especie: '',
        raca: ''
      }
    }
  },
  props: {
    pratica: {
      required: true
    }
  },
  computed: {
    disableButton () {
      return !(this.especiesRacas.especie && this.especiesRacas.raca)
    }
  },
  methods: {
    containsOption (lista, option) {
      if (!lista) {
        return false
      }

      return lista.includes(option)
    },
    btnAdicionar () {
      this.pratica.especiesRacas.push({
        ...this.especiesRacas
      })
      this.especiesRacas = {
        especie: '',
        raca: ''
      }
    },
    btnApagar (index) {
      this.pratica.especiesRacas.splice(index, 1)
    },
    btnEditar (especieRaca, index) {
      this.especiesRacas = {
        especie: especieRaca.especie,
        raca: especieRaca.raca
      }
      this.btnApagar(index)
    }
  }
}
</script>
<template>
    <div>
      <el-row :gutter="20">
        <validation-provider rules="area" v-slot="{ errors }" :name="nomeAba + '/Área'">
          <el-col :span="10">
            <Label label="Área" :obrigatorio="true" />
            <InputDouble
              :class="{ erro: errors.length, input: 'input' }"
              name='Área'
              :precision="2"
              :onkeypress="onlyInputNumbers"
              :showAppend ="true"
              v-model="pratica.area"
            />
            <span class="help erro">{{ errors[0] }}</span>
          </el-col>
        </validation-provider>
        <validation-provider rules="required" v-slot="{ errors }" :name="nomeAba + 'Número de animais por área (unidade/ha)'">
          <el-col :span="10">
            <Label label="Número de animais por área (unidade/ha) " :obrigatorio="true" />
            <InputDouble
              :class="{ erro: errors.length, input: 'input' }"
              name='Número de animais por área (unidade/ha) '
              :precision="0"
              :onkeypress="onlyInputNumbers"
              :showAppend ="true"
              v-model="pratica.numeroAnimais"
            />
            <span class="help erro">{{ errors[0] }}</span>
          </el-col>
        </validation-provider>
      </el-row>
      <el-row :gutter="20">
        <validation-provider rules="required" v-slot="{ errors }" :name="nomeAba + '/Data de início (mês/ano)'">
          <el-col :span="10">
            <Label label="Data de início (mês/ano)" :obrigatorio="true" />
            <el-date-picker
              v-model="pratica.dataInicio"
              type="month"
              placeholder="Selecione mês e ano"
              format="MM/yyyy"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            />
            <span class="help erro">{{ errors[0] }}</span>
          </el-col>
        </validation-provider>
        <InputSelect
          label="Tipo de sistema:"
          v-model="pratica.tiposSistemas"
          :nomeAba="nomeAba"
          :obrigatorio="true"
          rulesInput="required"
          :opcoes="opcoesTipoSistemaTI"
          :widthColumn="containsOption(pratica.tiposSistemas, 'OUTROS') ? 5 : 10"
          :multiSelect="true"
        />
        <validation-provider
            rules="required" v-slot="{ errors }" mode="lazy" :name="nomeAba + '/Qual?'"
            v-if="containsOption(pratica.tiposSistemas, 'OUTROS')"
          >
          <el-col :span="5">
            <Label label="Outro/qual?" :obrigatorio="true" />
            <el-input name="Outro/qual?" v-model="pratica.outrosTipoSistema" :class="{'input erro' : errors.length}" />
            <span class="help erro"> {{ errors[0] }}</span>
          </el-col>
        </validation-provider>
      </el-row>
      <el-row>
        <TitleWithRow title="Espécies e raças" />
        <el-row :gutter="20">
          <InputSelect
            label="Espécie"
            v-model="especiesRacas.especie"
            :nomeAba="nomeAba"
            :obrigatorio="true"
            :rulesInput="!pratica.especiesRacas.length ? 'required' : ''"
            :opcoes="opcoesEspecies"
            :widthColumn="10"
          />
          <el-col :span="10">
            <validation-provider :rules="!pratica.especiesRacas.length ? 'required' : ''" v-slot="{ errors }" mode="lazy" :name="nomeAba + '/Raça'">
              <Label label="Raça" :obrigatorio="!pratica.especiesRacas.length" />
              <el-input name="Raça" v-model="especiesRacas.raca" :class="{'input erro' : errors.length}" />
              <span class="help erro"> {{ errors[0] }}</span>
            </validation-provider>
          </el-col>
          <el-col :span="4">
            <div class="mb-1">&nbsp;</div>
            <el-button
              :disabled="disableButton"
              round type="primary"
              @click="btnAdicionar()"
            >
              Adicionar
            </el-button>
          </el-col>
        </el-row>

        <el-row :gutter="20" v-if="pratica.especiesRacas.length">
          <div class="flex-wrapper row">
            <div v-for="(e, i) in pratica.especiesRacas" :key="i+e.especie">
              <Card
                :objeto="{...e, especie: pratica.especiesRacas ? opcoesEspecies.find(especie => especie.id === e.especie).nome : '-' }"
                :deletar="() => btnApagar(i)"
                :editar="() => btnEditar(e, i)"
                titulo="Espécies e raças"
              />
            </div>
          </div>
        </el-row>
      </el-row>
      <el-row :gutter="20">
        <InputSelect
          label="Tipo de alimentação:"
          v-model="pratica.tiposAlimentacao"
          :nomeAba="nomeAba"
          :obrigatorio="true"
          rulesInput="required"
          :opcoes="opcoesTipoAlimentacao"
          :widthColumn="containsOption(pratica.tiposAlimentacao, 'OUTROS') ? 8 : 10"
          :multiSelect="true"
        />
        <validation-provider
            rules="required" v-slot="{ errors }" mode="lazy" :name="nomeAba + '/Qual?'"
            v-if="containsOption(pratica.tiposAlimentacao, 'OUTROS')"
          >
          <el-col :span="7">
            <Label label="Outro/qual?" :obrigatorio="true" />
            <el-input name="Outro/qual?" v-model="pratica.outroTipoAlimentacao" :class="{'input erro' : errors.length}" />
            <span class="help erro"> {{ errors[0] }}</span>
          </el-col>
        </validation-provider>
        <validation-provider rules="required" v-slot="{ errors }" :name="nomeAba + '/Suplementação mineral'">
          <InputSelect
            label="Suplementação mineral"
            v-model="pratica.hasSuplementacaoMineral"
            :nomeAba="nomeAba"
            :obrigatorio="true"
            rulesInput="required"
            :opcoes="opcoesSimNao"
            :widthColumn="containsOption(pratica.tiposAlimentacao, 'OUTROS') ? 8 : 10"
          />
        </validation-provider>
      </el-row>

      <Irrigacao :pratica="pratica" :nomeAba="nomeAba" />

      <Financiamentos :pratica="pratica" :nomeAba="nomeAba" />

      <el-row>
        <el-col :span="23">
            <Label label="Descrição" />
            <el-input
              name="Descrição" v-model="pratica.descricao"
              type="textarea"
              maxlength="500"
              show-word-limit
            />
          </el-col>
      </el-row>
    </div>
</template>



// WEBPACK FOOTER //
// src/App/(authenticated)/modulos/cadastro/formulario-cadastro/praticas/form-praticas/TI/TI.vue